import { endOfDay } from "date-fns";
import * as yup from "yup";
import { addDays } from "../../utils/dateUtils";

export type AddActivityDataFormValuesBase = {
    rawActivityQuantity: number;
    activityDate: Date;
    activityEndDate: Date;
};

export type AddActivityDataFormValues = AddActivityDataFormValuesBase;

export const AddActivityDataFormValidationSchema: (
    rawUnitsSuffix: string
) => yup.AnyObjectSchema = (rawUnitsSuffix: string) =>
    yup.object({
        rawActivityQuantity: yup
            .number()
            .required(`Please enter activity quanitity (${rawUnitsSuffix})`)
            .typeError(`Please enter activity quanitity (${rawUnitsSuffix})`)
            .moreThan(0, "Value must be greater than 0"),
        activityDate: yup
            .date()
            .typeError("Please enter a valid activity date")
            .max(endOfDay(new Date()), "Activity date must be today or earlier")
            .required("Please enter activity date"),
        activityEndDate: yup
            .date()
            .typeError("Please enter a valid activity date")
            .max(endOfDay(new Date()), "Activity end date must be today or earlier")
            .when("activityDate", (activityDate) => {
                return yup.date()
                    .min(activityDate, "Activity end date must be after start date");
            }),
    });


const date = new Date();

export const defaultAddActivityDataFormValues: AddActivityDataFormValues = {
    rawActivityQuantity: 0,
    activityDate: date ,
    activityEndDate: addDays(date)
};
